<div class="t-popup popup-patientDetails">
  <div class="t-popup-close"></div>
  <div
    class="t-popup-frame"
    style="display: flex; flex-direction: column"
    cdkDrag
    cdkDragBoundary=".t-popup"
  >
    <div
      [ngClass]="page === 'Patients' ? 'popup-nav-patients' : 'popup-nav-calendar'"
      style="cursor: grab"
      cdkDragHandle
    >
      <button
        class="search-btn"
        style="background-color: #6d7cab00; color: #277382; font-weight: 700; cursor: grab"
      >
        {{ "appointments.gui.labels.Select Patient" | translate | titlecase }}
      </button>
      <ng-container *ngIf="page !== 'Patients'">
        <img class="w10" src="assets/images/arr-right.svg" />
        <button class="search-btn" style="background-color: #6d7cab00; cursor: grab">
          {{ "appointments.gui.labels.Patient Details" | translate | titlecase }}
        </button>
        <img class="w10" src="assets/images/arr-right.svg" />
        <button class="search-btn" style="background-color: #6d7cab00; cursor: grab">
          {{ "appointments.gui.labels.Set Appointment" | translate | titlecase }}
        </button>
      </ng-container>
    </div>
    <button class="t-btn-popup-close" aria-label="close popup" (click)="closePatientModal()"></button>
    <div class="t-popup-body" style="height: 60vh">
      <h2 style="cursor: grab" cdkDragHandle>
        {{ "appointments.gui.labels.Search for a Patient" | translate | titlecase }}
      </h2>
      <div class="search-layout">
        <div class="userPanel">
          <div class="search-patient">
            <div class="search-patient-field">
              <div class="t-field l-flex t-twin-fieldset">
                <label>
                  <input
                    type="radio"
                    name="idp"
                    [(ngModel)]="idp"
                    [value]="1"
                    class="custom-check customInput"
                    aria-labelledby="pregnancy_popup-sex"
                  />
                  <i class="customInput-display"></i>
                  <span class="t-field-desc">
                    {{ "appointments.gui.labels.ID" | translate | titlecase }}
                  </span>
                </label>
                <label>
                  <input
                    type="radio"
                    name="idp"
                    [(ngModel)]="idp"
                    [value]="0"
                    class="custom-check customInput"
                    aria-labelledby="pregnancy_popup-sex"
                  />
                  <i class="customInput-display"></i>
                  <span class="t-field-desc">
                    {{ "appointments.gui.labels.Passport" | translate | titlecase }}
                  </span>
                </label>
              </div>
            </div>

            <div class="t-validation-wrap">
              <input
                type="text"
                class="search-patient-field idnumber"
                [ngClass]="invalidi"
                [placeholder]="'appointments.gui.placeholders.ID Number' | translate | titlecase"
                [attr.type]="idp == 1 ? 'number' : 'text'"
                [(ngModel)]="id"
                (keyup)="invalidi = ''; trysearch()"
                pattern="[A-Za-z0–9\-]+"
              />
              <div class="t-validation-message">
                <span>
                  {{ "appointments.gui.labels.Invalid ID Number" | translate | titlecase }}
                </span>
              </div>
            </div>

            <div class="t-validation-wrap">
              <input
                type="text"
                class="search-patient-field"
                [placeholder]="'appointments.gui.placeholders.First Name' | translate | titlecase"
                [ngClass]="invalidf"
                [(ngModel)]="first"
                (keyup)="invalidf = ''; trysearch()"
              />
              <div class="t-validation-message">
                <span>
                  {{ "appointments.gui.labels.Please fill in first name" | translate }}
                </span>
              </div>
            </div>

            <div class="t-validation-wrap">
              <input
                type="text"
                class="search-patient-field"
                [placeholder]="'appointments.gui.placeholders.Last Name' | translate | titlecase"
                [ngClass]="invalidl"
                [(ngModel)]="last"
                (keyup)="invalidl = ''; trysearch()"
              />
              <div class="t-validation-message">
                <span>
                  {{ "appointments.gui.labels.Please fill in last name" | translate }}
                </span>
              </div>
            </div>

            <div class="t-validation-wrap">
              <input
                type="tel"
                class="search-patient-field"
                placeholder="{{ 'appointments.gui.labels.Mobile' | translate | titlecase }} / {{ 'appointments.gui.placeholders.Phone' | translate | titlecase }}"
                [(ngModel)]="phone"
                (keyup)="invalidl = ''; trysearch()"
              />
              <div class="t-validation-message">
                <span>
                  {{ "appointments.gui.labels.Invalid phone" | translate }}
                </span>
              </div>
            </div>

            <div class="l-flex l-flex-w t-fieldmargin search-btns">
              <div class="w50">
                <button
                  class="search-btn"
                  [disabled]="isSearchButtonDisabled"
                  matTooltipPosition="after"
                  (click)="search(true); isReports = false; reportList = null"
                  [matTooltip]="'appointments.gui.tooltips.Search Patient' | translate | titlecase"
                >
                  {{ "appointments.gui.buttons.Search" | translate | titlecase }}
                </button>
              </div>
              <div class="w50">
                <button
                  class="search-btn"
                  matTooltipPosition="after"
                  (click)="clear()"
                  [ngClass]="
                    id.length > 0 || last.length > 0 || first.length > 0 || phone.length > 0
                      ? ''
                      : 'search-btn--clear'
                  "
                  [matTooltip]="'appointments.gui.tooltips.Clear Search Fields' | translate | titlecase"
                >
                  {{ "appointments.gui.buttons.Clear" | translate | titlecase }}
                </button>
              </div>
              <div class="w100">
                <button
                  class="search-btn search-btn--newPatient"
                  matTooltipPosition="after"
                  (click)="addPatient(); isReports = false"
                  [matTooltip]="'appointments.gui.tooltips.Open New Patient' | translate | titlecase"
                >
                  {{ "appointments.gui.buttons.New Patient" | translate | titlecase }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="isSearching">
          <main class="loading-container" [class.is-leaving]="isSearchingFading">
            <img src="assets/images/Wedges.svg" alt="Loading..." class="list-spinner-img" />
          </main>
        </ng-container>
        <ng-container *ngIf="!isSearching">
          @if (patList && patList.length === 0 && !isAWL) {
          <p class="empty-state">
            {{ 'GUI.Patients.empty.patients' | translate }}
          </p>
          } @else if (patList && !isAWL) {
          <div class="results-pane">
          <app-pagination-controls
            [total]="totalResults"
            [page]="currentPage"
            [totalPages]="totalPages"
            (prev)="previousPage()"
            (next)="nextPage()"
          ></app-pagination-controls>
          <div class="results-scroll" *ngIf="patList && patList.length">
            <div class="l-flex patient-item" *ngFor="let pat of patList">
              <button
                class="w100 patient-item-link"
                (click)="selectedPatient = pat; patservice.setPat(pat); closePatientModal('patDetails')"
                [matTooltip]="'appointments.gui.tooltips.Select Patient' | translate | titlecase"
              >
                <div class="l-table h100">
                  <span class="l-td-m patient-item-cell patient-id">
                    <span>
                      {{
                        pat.IsID
                          ? ("appointments.gui.labels.ID" | translate)
                          : ("appointments.gui.labels.Passport" | translate)
                      }}: <strong>{{ pat.ID }}</strong>
                    </span>
                  </span>

                  <span class="l-td-m patient-item-cell patient-name-first">
                    {{ pat.First }}
                  </span>

                  <span class="l-td-m patient-item-cell patient-name-last">
                    {{ pat.Last }}
                  </span>

                  <span class="l-td-m patient-item-cell patient-name-last">
                    {{ pat.Mobile ? pat.Mobile : pat.Phone }}
                  </span>
                  <!-- <span class="l-td-m patient-item-cell patient-name-first" *ngIf="loginService.separatedClinic && (loginService.isAdmin || loginService.userType == 'secretary')">
                            {{loginService.getDocByUID(pat.UID)}}
                        </span> -->
                </div>
              </button>
            </div>
          </div>
          </div>
          }
        </ng-container>
      </div>
    </div>
  </div>
</div>
